import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { FC } from 'react';

export const MyAnalyticsPageSkeleton: FC = () => (
  <Box sx={{ minHeight: 'calc(100vh - 140px)' }}>
    {/* Breadcrumb */}
    <Box display="flex" gap={1} mb={2} alignItems="center">
      <Skeleton variant="text" width={120} height={20} />
      <Skeleton variant="text" width={8} height={20} />
      <Skeleton variant="text" width={160} height={20} />
    </Box>

    {/* Description */}
    <Box mb={3} sx={{ maxWidth: { xs: '100%', md: 'calc(100% - 315px)' } }}>
      <Skeleton variant="text" width="90%" height={18} />
      <Skeleton variant="text" width="70%" height={18} />
    </Box>

    {/* Rule cards */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, maxWidth: { xs: '100%', md: 'calc(100% - 205px)' } }}>
      {Array.from({ length: 2 }).map((_, cardIndex) => (
        // oxlint-disable-next-line react/no-array-index-key
        <Box key={cardIndex} sx={{ border: theme => `1px solid ${theme.palette.divider}`, borderRadius: 2, p: 2 }}>
          <Skeleton variant="text" width={220} height={28} />
          <Skeleton variant="text" width={180} height={18} sx={{ mb: 1.5 }} />
          <Box display="flex" alignItems="center" gap={2} mb={2}>
            <Skeleton variant="text" width={36} height={24} sx={{ flexShrink: 0 }} />
            <Skeleton variant="rectangular" height={10} sx={{ flex: 1, borderRadius: 3 }} />
          </Box>
          {Array.from({ length: 5 }).map((_, rowIndex) => (
            // oxlint-disable-next-line react/no-array-index-key
            <Skeleton key={rowIndex} variant="rectangular" height={56} sx={{ mb: '1px' }} />
          ))}
        </Box>
      ))}
    </Box>
  </Box>
);
